import { Swiper, Navigation } from '@hh/global.js'

class AskMother extends HTMLElement {
  constructor() {
    super()

    Swiper.use([Navigation]);
    var swiper = new Swiper(this.querySelector('.js-slider'), {
      navigation: {
        nextEl: this.querySelector('.js-next'),
        prevEl: this.querySelector('.js-prev'),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        type: "progressbar",
      },
    })
  }
}

customElements.define('ask-mother', AskMother)
